<script setup>
import { Inertia } from '@inertiajs/inertia';
import Layout from '../../Components/Shared/Layout.vue';
import ButtonComponent from '../../Components/Shared/ButtonComponent.vue';
import HarvestForm from '../../Components/Forms/HarvestForm.vue';

const props = defineProps({
    farm: Object,
    fruits: Array,
});

const harvestAdded = harvest => {
    Inertia.visit(`/portfolio/harvest/${harvest.id}`);
};
</script>

<template>
    <Layout>
        <section class="w-full px-3 py-5 mx-auto sm:px-6 lg:px-10 xl:px-14">
            <header class="mb-5">
                <ButtonComponent
                    :content="`Volver a ${farm.name}`"
                    :icon="'arrow_back_ios'"
                    :link="`/portfolio/farm/${farm.id}`"
                    type="2"
                />
                <h1 class="text-2xl font-bold text-enriqueto_green sm:text-3xl">Nueva cosecha</h1>
                <p class="mt-1 text-gray-700">
                    Selecciona el producto y abriremos automáticamente el mapa adecuado según su categoría.
                </p>
            </header>

            <div class="p-4 bg-white border-2 border-light_green rounded-2xl sm:p-6">
                <HarvestForm :farm="farm" :fruits="fruits" @added="harvestAdded" />
            </div>
        </section>
    </Layout>
</template>
